import InboomaBaseModel from './InboomaBaseModel';

export default InboomaBaseModel.extend({

  urlRoot : '/events',

  _timeFilter : [
    'start',
    'end',
    'valid_from',
    'valid_to'
  ],

  _rbac : {
    "admin" : {
      "read" : true,
      "write" : true,
      "edit" : true,
      "remove" : true,
    },
    "user" : {
      "read" : false,
      "write" : false,
      "edit" : false,
      "remove" : false
    }
  },

  unsetWeekdays() {
    this.set('day_of_week_1', '');
    this.set('day_of_week_2', '');
    this.set('day_of_week_3', '');
    this.set('day_of_week_4', '');
    this.set('day_of_week_5', '');
    this.set('day_of_week_6', '');
    this.set('day_of_week_7', '');
    return this;
  },

  defaults : {
    "id" : "",
    "title"  : "",
    "start" : "",
    "end" : "",
    "all_day" : false,
    "contingent_id" : "",
    "calendar_id" : "",
    "url" : "",
    "reminder" : "",
    "duration" : "",
    "rrule" : "",
    "is_recurring" : false,
    "recurring_type" : "",
    "separation_count" : "",
    "valid_from" : "",
    "valid_to" : "",
    "day_of_week_1" : "",
    "day_of_week_2" : "",
    "day_of_week_3" : "",
    "day_of_week_4" : "",
    "day_of_week_5" : "",
    "day_of_week_6" : "",
    "day_of_week_7" : "",
    "day_of_month" : "",
    "week_of_month" : "",
    "month_of_year" : "",
    "created" : "",
    created_by : "",
    "modified" : "",
    modified_by : ""
  } 
})